import React, { useState } from "react";
import Benefit from '../../shared/benefit/benefit';
import Loader from '../../../components/common/loader';
import * as analytics from '../../../constants/analytics';
import * as contentApi from '../../../redux/api/content.api';
import Page404 from '../../page404';

import ReactHtmlParser from "react-html-parser";
import {reactParserCommonOptions} from '../../../app/functions';
import HeaderGallery from "pages/customer-join/sections/HeaderGallery";
import { useDispatch, useSelector } from 'react-redux';
import { addPopup, removePopup } from '../../../redux/actions';
import * as popups from '../../../constants/popup-types';
import * as routes  from "../../../constants/routes";
import { useHistory } from "react-router-dom";
import { commerceApi } from "../../../redux/api/commerce.api";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import MemoryGameModal from './memory-game/MemoryGameModal';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

export function PresentBenefitsPage() {
    const params = useParams();

    const dispatch = useDispatch();
    const translations = useSelector((store) => store.config.Translations);
    const userData = useSelector((store) => store.config.UserData);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const [getPageData, {data, isLoading, isSuccess, isError,isFetching,isUninitialized}] = contentApi.useLazyGetPresentBenefitsPageQuery();

    const [selectPresentBenefit] = commerceApi.useSelectPresentBenefitMutation();
    
    const [topGalleryDesktop, setTopGalleryDesktop] = useState([]);
    const [topGalleryMobile, setTopGalleryMobile] = useState([]);
    const [bottomGalleryDesktop, setBottomGalleryDesktop] = useState([]);
    const [bottomGalleryMobile, setBottomGalleryMobile] = useState([]);
    const [bottomBannerLink, setBottomBannerLink] = useState(null);
    const [showMemoryGame, setShowMemoryGame] = useState(false);
    const [selectedBenefitApproveText, setSelectedBenefitApproveText] = useState(null);

    const gameKey = `memoryGame_${params.name || 'default'}`;

    useEffect(() => {
        setTopGalleryDesktop(data?.topBannerDesktop ? [{id: 0, imagePath: data?.topBannerDesktop}] : []);
        setTopGalleryMobile(data?.topBannerMobileViewWebsite ? [{id: 0, imagePath: data?.topBannerMobileViewWebsite}] : []);
        setBottomGalleryDesktop(data?.bottomBannerDesktop ? [{id: 0, imagePath: data?.bottomBannerDesktop}] : []);
        setBottomGalleryMobile(data?.bottomBannerMobileViewWebsite ? [{id: 0, imagePath: data?.bottomBannerMobileViewWebsite}] : []);
        setBottomBannerLink(data?.bottomBannerLink);
        setSelectedBenefitApproveText(data?.selected_benefit_approve_text);
        const { message, isValid, generalErrorMessage } = data || {};

        const isMemoryGame = data?.memoryGame?.images?.length > 0;
        
        if (isValid === true && isMemoryGame) {
            // Check if user has already won this memory game
            const hasWon = checkMemoryGameWinStatus();
            if (!hasWon) {
                setShowMemoryGame(true);
            }
        } else if (isValid === false){
            if (message && !generalErrorMessage){
                const displaySendAgainText = data?.selectedBenefit != null ? true : false;
                showMessagePopup({message: message, displaySendAgainText: displaySendAgainText});
            }
        }
    }, [data]);

    const showSelectionPopup = (benefit, message) => {
        const approveText = selectedBenefitApproveText?.replace('{benefit_title}', benefit.title) || `זו ההטבה שבחרת: <b>${benefit.title}</b><br/>`;
        dispatch(addPopup({
            type: popups.GENERAL_MESSAGE,
            text: ReactHtmlParser(
                approveText,
                reactParserCommonOptions()
            ),
            action: () => selectPresentBenefit({ benefitId: String(benefit.id), slug: params.name, isAlreadySelected: false }),
            afterAction: (response) => {
                if (response?.data?.success) {
                    showMessagePopup({message: message, redirectToHome: true});
                } else {
                    const errorMessage = response?.data?.message
                        ? data?.acquired_present_benefit
                        : translations?.general_error_message || "אירעה שגיאה, נסה שוב מאוחר יותר";
                    showMessagePopup({message: errorMessage, redirectToHome: false});
                }
            }
        }));
    };

    const history = useHistory();

    const showMessagePopup = ({message, displaySendAgainText = false, redirectToHome = true}) => {
        dispatch(addPopup({
            type: popups.GENERAL_MESSAGE,
            text: ReactHtmlParser(message, reactParserCommonOptions()),
            sendAgainText: displaySendAgainText ? data?.send_coupon_again_button_text || 'שלח שוב' : null,
            sendAgainAction: () => {
                return selectPresentBenefit({ benefitId: String(data?.selectedBenefit), slug: params.name, isAlreadySelected: true });
            },
            afterSendAgainAction: (response) => {
                if (response?.data?.success) {
                    return {
                        text: ReactHtmlParser(data?.send_coupon_again_popup_success_message || 'הקופון נשלח שוב', reactParserCommonOptions()),
                        hideSendAgain: true
                    };
                } else {
                    return {
                        text: ReactHtmlParser(data?.send_coupon_again_popup_error_message || 'אירעה שגיאה, נסה שוב מאוחר יותר', reactParserCommonOptions()),
                        hideSendAgain: true
                    };
                }
            },
            keepPopupOpenOnSendAgain: true,
            action: () => {
                if (redirectToHome) {
                    history.push(routes.home);
                }
            },
            onClose: () => {
                if (redirectToHome) {
                    history.push(routes.home);
                }
            }
        }));
    };


    const handleBannerClick = (link) => {
        const newWindow = window.open(link, '_blank', 'noopener,noreferrer');
        if (newWindow) newWindow.opener = null;
    }

    const handleGameCompleted = () => {
        saveMemoryGameWinStatus();
    };

    const handleCloseMemoryGame = () => {
        setShowMemoryGame(false);
    };

    // Check if user has already won this memory game
    const checkMemoryGameWinStatus = () => {
        try {
            const hasWon = localStorage.getItem(gameKey);
            return hasWon === 'true';
        } catch (error) {
            return false;
        }
    };

    // Save memory game win status to localStorage
    const saveMemoryGameWinStatus = () => {
        try {
            localStorage.setItem(gameKey, 'true');
        } catch (error) {
            console.error('Error saving memory game win status:', error);
        }
    };

    // Reset memory game win status (for testing)
    const resetMemoryGameWinStatus = () => {
        try {
            localStorage.removeItem(gameKey);
        } catch (error) {
            console.error('Error resetting memory game win status:', error);
        }
    };

    // Debug method to clear all memory game data
    const clearAllMemoryGameData = () => {
        try {
            const keys = Object.keys(localStorage);
            const memoryGameKeys = keys.filter(key => key.startsWith('memoryGame_'));
            memoryGameKeys.forEach(key => localStorage.removeItem(key));
        } catch (error) {
            console.error('Error clearing all memory game data:', error);
        }
    };

    // Add debug functions to window for testing
    useEffect(() => {
        if (typeof window !== 'undefined') {
            window.resetMemoryGameWinStatus = resetMemoryGameWinStatus;
            window.clearAllMemoryGameData = clearAllMemoryGameData;
            window.checkMemoryGameWinStatus = checkMemoryGameWinStatus;
        }

        if(!userData) {
            dispatch(addPopup({
            type: popups.LOGIN,
            onLogin: ()=> window.location.reload(),
            onClose: () => {
                 window.location.reload()
                },
            }))
        }else{
            getPageData({
                name: params.name
            })
        }
    }, []);

    if (isLoading || isFetching) return (<Loader className="initial-loader"/>)
    if (!userData || isUninitialized) return null;
    if((isSuccess && !data?.benefits) || isError) return <Page404/>;

    return (
        <main className='benefits-page_container'>
          <div id="free-search-wrapper" className="free-search-wrapper">
                {((isMobile && topGalleryMobile.length > 0) || (!isMobile && topGalleryDesktop.length > 0)) && <HeaderGallery 
                    data={{galleryDesktop: topGalleryDesktop, galleryMobile: topGalleryMobile}} 
                />}
                <div className='result-wrapper'>
                {data.header_html ? ReactHtmlParser(data.header_html, reactParserCommonOptions()) : null}
                </div>
        
                <div className="result-wrapper">
                {(data?.benefits?.length > 0) 
                    && data.benefits.map((benefit) => (
                        <Benefit
                            key={benefit.id}
                            data={benefit}
                            analyticsSource={analytics.AnalyticsParamValues.SEARCH_RESULTS_SOURCE}
                            isSelectBenefit={true}
                            benefitId={benefit.id}
                            setSelectedId={() => showSelectionPopup(benefit, data.message)}
                        />
                ))}
                </div>
                {((isMobile && bottomGalleryMobile.length > 0) || (!isMobile && bottomGalleryDesktop.length > 0)) && <HeaderGallery 
                    data={{galleryDesktop: bottomGalleryDesktop, galleryMobile: bottomGalleryMobile}} 
                    onClick={() => handleBannerClick(bottomBannerLink)}
                />}
            </div>

            {showMemoryGame && (
                <MemoryGameModal
                    memoryGame={data?.memoryGame}
                    user={userData}
                    onClose={handleCloseMemoryGame}
                    onGameCompleted={handleGameCompleted}
                />
            )}
        </main>
  );    
}
